import { Group, Stack, Text, ThemeIcon } from '@mantine/core';

import {
  IconAsterisk,
  IconCheck,
  IconInfoSquareRounded,
  IconPaperclip,
} from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

export function DropzoneLabel({
  label,
  inputHasFiles = false,
  isMandatory = false,
}: {
  label: React.ReactNode;
  inputHasFiles?: boolean;
  isMandatory?: boolean;
}) {
  const { t } = useTranslation('buyerSimulation');

  return (
    <Stack spacing="01" w="100%">
      <Group noWrap spacing="02" c="gray.4" m="auto">
        {inputHasFiles ? (
          <ThemeIcon color="teal.6" size="sm">
            <IconCheck />
          </ThemeIcon>
        ) : (
          <IconPaperclip />
        )}
        <Text variant="sm" fw="500" c="gray.5">
          {label}
        </Text>
        {isMandatory && (
          <ThemeIcon
            size="xs"
            variant="light"
            sx={theme => ({
              backgroundColor: theme.colors.primary[1],
              color: theme.colors.primary[6],
              borderRadius: theme.radius.xl,
            })}
          >
            <IconAsterisk size={8} stroke={3} />
          </ThemeIcon>
        )}
        <IconInfoSquareRounded />
      </Group>
      <Text variant="xs" fw="400" c="gray.4" m="auto">
        {t('createBidResponseModal.dropzone.fileType')}
      </Text>
    </Stack>
  );
}

export function BlueHighlight({ children }: React.HTMLProps<HTMLSpanElement>) {
  return (
    <Text variant="sm" fw="500" c="primary.6" component="span">
      {children}
    </Text>
  );
}
